import { render, staticRenderFns } from "./new1.vue?vue&type=template&id=04af05e9&scoped=true&"
import script from "./new1.vue?vue&type=script&lang=js&"
export * from "./new1.vue?vue&type=script&lang=js&"
import style0 from "./new1.vue?vue&type=style&index=0&id=04af05e9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04af05e9",
  null
  
)

export default component.exports